import React,{useEffect, useState} from 'react';
import { Link, useNavigate } from "react-router-dom";
import ErrorPopup from "../common/ErrorPopup";
import { useRole } from "../contextApi/RoleContext";
import { API } from "../../helper/Api";


function SalesReportFilter() {
    const navigate = useNavigate();
      const { setRole, role, setPermission, permission, setUserDetails,userDetails} =useRole();
    const [fromDate, setFromDate] = useState("");
      const [toDate, setToDate] = useState("");
      const [storeCode, setStoreCode] = useState([]);
      const [selectedStore,setSelectedStore]=useState('');
      const [pending, setPending] = useState(true);

      const API_URL = process.env.REACT_APP_BASE_URL;

      ///get the store code /////
   const fetchStoreCode = async () => {
    try {
      const res = await fetch(`${API_URL}location.php`);
      // Check if the response is successful (status 200)
      if (!res.ok) {
        throw new Error("Network response was not ok");
      }
      const result = await res.json();
      console.log(result)
      const extractCode = result.ApiDocument.Response.Locations.map(
        (item) => {
          return { code: item.Code,name: item.Name };
        }
      ).filter((item) => item.code);
     // console.log("test",extractCode)
      setStoreCode(extractCode);
      // if(userDetails.usertype !=="CORP"){
      //   const filterCodeBasedOnUser= extractCode.filter(item => userDetails.storecode.some(its=> its.storecode === item.code));
      //   setStoreCode(filterCodeBasedOnUser);
      //   console.log("filtered code",filterCodeBasedOnUser)
      // }else{
      //   setStoreCode(extractCode);
      // }
      
       console.log("store code", extractCode);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };


  const handleApply = (e) => {
    e.preventDefault();
    if(!fromDate && !toDate){
      // setErrors({fromDate:'fromDate is required..'});
      // setErrors({toDate:'toDate is required..'});
      // setShowPopup(true);
    }else{
      const url = `/sales-report?store=${selectedStore}&fromDate=${fromDate}&toDate=${toDate}`;

      navigate(url);
    }
    

  };

  // const getSalesReport = () => {
  //   setPending(true);
  //   API.getSalesOrderRecipts()
  //     .then((datas) => {

  //         navigate("/sales-report");


  //     })
  //     .catch((err) => console.log(err));
  // };



  //////////////////////////////
useEffect(()=>{
fetchStoreCode();
},[])


/////store code handleselect
const handleSelect=(e)=>{
setSelectedStore(e.target.value)
}

////////

    ///FORM SUBMIT///
  const handleFormSubmit = (e) => {
    e.preventDefault();

  };

  const selectStyles = {
    width: "100%",
    padding: "8px",
    fontSize: "14px",
    borderRadius: "4px",
    border: "1px solid #ced4da",
    backgroundColor: "#fff",
    marginTop:"-3px",
    outline: "none",
    cursor: "pointer",
    height: "47px",
    color: "black",
  };
    return (
        <>
        {/* <ToastContainer
        position="top-center"
        autoClose={500}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      /> */}
{/* {showPopup && <ErrorPopup errors={errors} onClose={closePopup} />} */}
    <div className="main-panel">
      <div className="content-wrapper">
        <div className="container mainbody22">

          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <h2 className="form-header">SalesReportFilter</h2>
            {/* <Link to="/sales-report" className="backButton">
              <i class="mdi mdi-arrow-left"></i>Back
            </Link> */}
          </div>
          <div className="row mt-3">
                <>
                  <div className="col-md-4">
                    <label htmlFor="fromDate" className="form-label">
                      From Date
                    </label>
                    <input
                      type="date"
                      id="fromDate"
                      className="form-control"
                      // style={{ width: "50%" }}
                      value={fromDate}
                      onChange={(e)=>setFromDate(e.target.value)}
                    />
                  </div>
                  <div className="col-md-4">
                    <label htmlFor="toDate" className="form-label">
                      To Date
                    </label>
                    <input
                      type="date"
                      id="toDate"
                      // style={{ width: "50%" }}
                      className="form-control"
                      value={toDate}
                       onChange={(e)=>setToDate(e.target.value)}
                    />
                  </div>
                  {userDetails.usertype ==="CORP"? (
                     <div className="col-md-4">
                     <label htmlFor="toDate" className="form-label">
                       Store
                     </label>
                     <select  style={selectStyles} onChange={handleSelect}>
                         <option value=''>Select Store</option>
                         {storeCode.filter(it=> it.code !== "HQ" && it.code !== "INTRANSIT" && it.code !== "TEST").map((item)=>{
                             return <option value={item.code}>{item.name}</option>
                         })}
                     </select>
                   </div>
                  ):(null)}
                 

                  
                </>{" "}
              </div>
              <div style={{textAlign:"center",marginTop:"38px"}}>
                    <button
                      className="btn btn-primary w-72"
                      style={{width:"14%" }}
                     onClick={handleApply}
                    >
                      APPLY
                    </button>
                  </div>

      </div>
      </div>
    </div>
    </>

    );
}

export default SalesReportFilter;